import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getCurrentUser } from '../services/authService';
import { PixelHourglass } from './PixelHourglass';

interface OnboardingGuardProps {
  children: React.ReactNode;
}

const OnboardingGuard = ({ children }: OnboardingGuardProps) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    checkOnboardingStatus();
  }, [location.pathname]);

  const checkOnboardingStatus = async () => {
    try {
      const user = await getCurrentUser();

      const isOnboardingRoute = location.pathname.startsWith('/onboarding');
      const isStep1 = location.pathname === '/onboarding/step-1';

      // If onboarding done and trying to access any onboarding route, redirect to homepage
      if (user.onboarding_done && isOnboardingRoute) {
        navigate('/', { replace: true });
      }
      // If onboarding not done and trying to access main app, redirect to step-1
      else if (!user.onboarding_done && !isOnboardingRoute) {
        navigate('/onboarding/step-1', { replace: true });
      }
    } catch (err) {
      console.error('Failed to check onboarding status:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div
        className="min-h-screen bg-[#ffffeb] pb-24 flex items-center justify-center"
        style={{
          backgroundImage: `
            repeating-linear-gradient(0deg, transparent, transparent 7px, rgba(7, 127, 93, 0.03) 7px, rgba(7, 127, 93, 0.03) 8px),
            repeating-linear-gradient(90deg, transparent, transparent 7px, rgba(7, 127, 93, 0.03) 7px, rgba(7, 127, 93, 0.03) 8px)
          `
        }}
      >
        <PixelHourglass size="large" speed="fast" color="keppel" data-id="budget-status-loader" />
      </div>
    );
  }

  return <>{children}</>;
};

export default OnboardingGuard;
